/**
 * Operator-facing sales-order status. Keep in sync with
 * `src/sales-order/sales-order-hub-status.ts`.
 *
 * Hub stores and shows Approved. Megaventory still uses Verified on the wire.
 */

export function isSalesOrderHubApprovedStatus(value: unknown): boolean {
  const normalized = String(value ?? "").trim().toLowerCase();
  return normalized === "verified" || normalized === "approved";
}

export function isSalesOrderHubPendingStatus(value: unknown): boolean {
  return String(value ?? "").trim().toLowerCase() === "pending";
}

export function salesOrderStatusLabel(status: string | null | undefined): string {
  const trimmed = status?.trim() ?? "";
  if (trimmed === "") {
    return "Unknown";
  }
  if (isSalesOrderHubApprovedStatus(trimmed)) {
    return "Approved";
  }
  return trimmed.replace(/([a-z\d])([A-Z])/g, "$1 $2");
}
